// TEXT TRUNCATION UTILITY
class TextTruncator {
    constructor(options = {}) {
      this.options = {
        maxLines: options.maxLines || 2,
        readMoreText: options.readMoreText || 'Read More',
        readLessText: options.readLessText || 'Read Less',
        truncateClass: options.truncateClass || 'js-truncate',
        expandedClass: options.expandedClass || 'is-expanded',
        animationDuration: options.animationDuration || 300
      };
      
      this.init();
    }
  
    init() {
      // Add transition styles
      const style = document.createElement('style');
      style.textContent = `
        .${this.options.truncateClass} {
          position: relative;
        }
        .${this.options.truncateClass}__content {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: ${this.options.maxLines};
          overflow: hidden;
          transition: all ${this.options.animationDuration}ms ease-in-out;
        }
        .${this.options.truncateClass}.${this.options.expandedClass} .${this.options.truncateClass}__content {
          -webkit-line-clamp: unset;
        }
        .${this.options.truncateClass}__toggle {
          background: none;
          border: none;
          padding: 0;
          font: inherit;
          color: inherit;
          cursor: pointer;
          text-decoration: underline;
          margin-top: 0;
          margin-bottom: 10px;
          font-size: 14px;
          display: inline-block;
        }
        .${this.options.truncateClass}__toggle:hover {
          opacity: 0.7;
        }
      `;
      document.head.appendChild(style);
  
      // Use event delegation for better performance
      document.addEventListener('click', (e) => {
        if (e.target.matches(`.${this.options.truncateClass}__toggle`)) {
          this.toggleText(e.target);
        }
      });
  
      // Initialize truncation after DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.truncateAll());
      } else {
        this.truncateAll();
      }
  
      // Handle dynamic content loading (e.g., Shopify sections)
      document.addEventListener('shopify:section:load', (event) => {
        this.truncateAll(event.target);
      });
    }
  
    truncateAll(container = document) {
      const textBlocks = container.querySelectorAll(`.${this.options.truncateClass}`);
      
      textBlocks.forEach(block => {
        if (!block.dataset.initialized) {
          this.setupTextBlock(block);
        }
      });
    }
  
    setupTextBlock(block) {
      // Create content wrapper
      const content = document.createElement('div');
      content.className = `${this.options.truncateClass}__content`;
      
      // Move all existing content into the content wrapper
      while (block.firstChild) {
        content.appendChild(block.firstChild);
      }
      
      // Create toggle button
      const toggle = document.createElement('button');
      toggle.className = `${this.options.truncateClass}__toggle`;
      toggle.textContent = this.options.readMoreText;
      toggle.setAttribute('aria-expanded', 'false');
      
      // Add content and toggle to the block
      block.appendChild(content);
      block.appendChild(toggle);
      
      // Mark as initialized
      block.dataset.initialized = 'true';
    }
  
    toggleText(toggleButton) {
      const block = toggleButton.closest(`.${this.options.truncateClass}`);
      const isExpanded = block.classList.contains(this.options.expandedClass);
      
      // Toggle classes
      block.classList.toggle(this.options.expandedClass);
      
      // Update button text and aria state
      toggleButton.textContent = isExpanded ? this.options.readMoreText : this.options.readLessText;
      toggleButton.setAttribute('aria-expanded', !isExpanded);
    }
  }
  
  // Initialize truncator
  const textTruncator = new TextTruncator();
  
  // Export for potential use in other scripts
  window.TextTruncator = TextTruncator;